import validate from "/opt/atlassian/pipelines/agent/build/node_modules/nuxt/dist/pages/runtime/validate.js";
import active_45session_45global from "/opt/atlassian/pipelines/agent/build/middleware/active-session.global.ts";
import check_45iframe_45global from "/opt/atlassian/pipelines/agent/build/middleware/check-iframe.global.ts";
import inactivity_45global from "/opt/atlassian/pipelines/agent/build/middleware/inactivity.global.ts";
import locale_45global from "/opt/atlassian/pipelines/agent/build/middleware/locale.global.ts";
import manifest_45route_45rule from "/opt/atlassian/pipelines/agent/build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  active_45session_45global,
  check_45iframe_45global,
  inactivity_45global,
  locale_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/opt/atlassian/pipelines/agent/build/middleware/auth.ts"),
  guest: () => import("/opt/atlassian/pipelines/agent/build/middleware/guest.ts")
}